/* eslint-disable import/prefer-default-export */
import { css } from '@emotion/css';

const wrapper = css`
  display: flex;
  gap: 1rem;
  width: 100%;
  flex-wrap: nowrap;
  transition: transform 0.3s ease-in-out;
  will-change: transform;
  position: relative;
  scrollbar-width: none;
  overflow-x: auto;
`;

const controls = css`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  background-color: rgba(255, 255, 255, 0.5);
  border-radius: 50%;
  padding: 0.5rem;
  cursor: pointer;
  z-index: 10;
`;

const prevButton = css`
  left: -45px;
`;

const nextButton = css`
  right: -45px;
`;

export const TabsWalletsStyles = {
  wrapper,
  controls,
  prevButton,
  nextButton,
};
